import { render, staticRenderFns } from "./MoAffix.vue?vue&type=template&id=4b2d9d87&"
import script from "./MoAffix.vue?vue&type=script&lang=js&"
export * from "./MoAffix.vue?vue&type=script&lang=js&"
import style0 from "./MoAffix.vue?vue&type=style&index=0&id=4b2d9d87&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports